export const getDataTypeDisplay = (value: string) => {
    if (value === 'pmId') {
        return 'PM Id';
    } else if (value === 'fhirId') {
        return 'FHIR Id';
    } else if (value === 'email') {
        return 'Email';
    }
}